import Button from '@/components/Buttons/Button';
import styled from '@emotion/styled';

export const Content = styled.div<{ show?: boolean }>`
    display: ${({ show }) => (show === false ? 'none' : 'flex')};
    flex-direction: column;
    min-width: 700px;
    padding-bottom: 40px;
    width: 100%;
`;

export const Title = styled.div`
    color: ${({ theme }) => theme.colors.secondary.main};
    text-align: center;
    font-size: 40px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.8px;
    margin-bottom: 16px;
    margin-block-start: 32px;
    margin-block-end: 32px;
`;

export const Back = styled.img`
    display: flex;
    width: 52px;
    height: 52px;
    margin-bottom: 16px;
    cursor: pointer;
`;

export const Subtitle = styled.div`
    color: ${({ theme }) => theme.colors.secondary[600]};
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 125%;
    letter-spacing: -0.4px;
    width: 413px;
`;

export const Question = styled.div`
    color: ${({ theme }) => theme.colors.secondary[700]};
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: -0.36px;
    margin-bottom: 4px;
    margin-block-start: 52px;
`;

export const Section = styled.div<{ show?: boolean; fullWidth?: boolean }>`
    display: ${({ show }) => (show === false ? 'none' : 'flex')};
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: ${({ fullWidth }) => (fullWidth ? '100%' : 'unset')};
`;

export const PurposeNextSection = styled(Section)`
    display: flex;
    justify-content: space-between;
    bottom: 0;
    position: absolute;
    margin-block-end: 39px;
    margin-inline-start: 582px;
`;

export const BackAndForthSection = styled.div`
    display: flex;
    justify-content: space-between;
    width: 722px;
    bottom: 0;
    position: absolute;
    margin-block-end: 39px;
`;

export const HorizontalSection = styled(Section)<{ hasBack?: boolean }>`
    display: grid;
    grid-template-columns: ${({ hasBack }) => (hasBack ? '52px auto' : 'auto')};
    width: 100%;
    justify-content: unset;
`;

export const ActionButton = styled(Button)`
    color: ${({ theme }) => theme.colors.white};
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    width: 140px;
    margin-top: 24px;
    display: flex;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    height: 48px;
`;

export const BackButton = styled(ActionButton)`
    border: 2px solid #d3d3d3;
    width: 100px;
`;

export const ChipContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    width: 355px;
    gap: 12px;
    margin-top: 32px;
`;
